import { render, staticRenderFns } from "./compManage.vue?vue&type=template&id=687a3c28&scoped=true"
import script from "./compManage.vue?vue&type=script&lang=js"
export * from "./compManage.vue?vue&type=script&lang=js"
import style0 from "./compManage.vue?vue&type=style&index=0&id=687a3c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687a3c28",
  null
  
)

export default component.exports